/* eslint-disable react-hooks/exhaustive-deps */
import { AiFillCloseCircle } from "react-icons/ai";
import { BsPatchCheckFill } from "react-icons/bs";
import { Link, useParams } from "react-router-dom";
import "./verify-email.css";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { verifyEmail } from "../../redux/apiCalls/authApiCall";

const VerifyEmail = () => {
  const { userId, token } = useParams();
  const dispatch = useDispatch();
  const isEmailVerified = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(verifyEmail(userId, token));
  }, [userId, token]);


  return (
    <div className="verify-email">
      {!isEmailVerified.isEmailVerified ? (
        <>
          <AiFillCloseCircle className="verify-email-icon-x" />
          <h3 className="verify-email-not-found">عفواً لا يوجد اميل محقق !</h3>
        </>
      ) : (
        <>
          <h3 className="verify-email-title">تم التحقق من الاميل بنجاح</h3>
          <BsPatchCheckFill className="verify-email-icon" />
          <Link className="verify-link" to="/login">
            اضغط هنا الان للتسجيل فى الموقع
          </Link>
        </>
      )}
    </div>
  );
};

export default VerifyEmail;
